<template>
    <BaseDialog :close-on-mask="closeOnMask" @reject="onClose">
        <div class="team-dialog u-dialog">
            <div class="dialog-content">
                <div class="u-btn close" @click="onClose"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="team-view">
                        <simplebar class="scroll-area" data-simplebar-auto-hide="false">
                        <div class="team-pannel">
                            <div class="team-item" v-for="(team, teamId, index) in matchData.teams" :key="index">
                                <div class="team-name" :class="'t-' + (index + 1)"></div>
                                <div class="team-list flex-between-center">
                                    <div class="player-item" v-for="(p,k) in team.players" :key="k" :class="['p-'+ (k+1) , 't-' + (index + 1)]">
                                        <div class="name-label" :class="['p-'+ (k+1) , 't-' + (index + 1)]"></div>
                                        <div class="score">{{ p.score }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </simplebar>
                    </div>                   
                </div>
            </div>            
        </div> 
    </BaseDialog>
</template>
<script>
import BaseDialog from '../BaseDialog.vue'

export default {
    name: 'TeamDetailDialog',
    components: {
        BaseDialog,
    },
    props: {
        closeOnMask: {
            type: Boolean,
            default: true
        },
        config: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        matchData() {
            return this.$store.state.match_data;
        }
    },
    methods: {
        onClose() {
            this.$emit('resolve', false)
        },
    }
}
</script>

<style lang="scss" scoped>
.team-name{
    width: 512px;
    height: 44px;
    margin: 5px auto 5px;
}

@for $i from 1 through 8 {
.team-name.t-#{$i} {
    background-image: url(~@/assets/images/modal/t-#{$i}.png);
}
}

@include responseTo("desktop"){
.team-dialog{
    width: 1182px;
    height: 805px;
    background-image: url(~@/assets/images/modal/bg-modal-pc.png);  
}

.title{
    width: 100%;
    height: 47px;
    margin: 0 auto 20px;
    background-repeat : no-repeat;
    background-position : center;
    
    background-image: url(~@/assets/images/modal/title-team.png);  
}

.name-label{
    position: absolute;
    right: 0px;
    top: 14px;
    width: 28px;
    height: 71px;  
    background-repeat : no-repeat;
}

@for $i from 1 through 8 {

    @for $k from 1 through 5 {
        .name-label.t-#{$i}.p-#{$k} {
            background-image: url(~@/assets/images/modal/name-PC/#{$i}-#{$k}.png);
        }
    }
}

.team-view{
    margin : 0 20px;
}

.scroll-area{
    height: 650px;
    margin: 0 auto;
}

.team-pannel{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 40px;
}

.team-item{
    width: 500px;
}

.player-item{
    position: relative;
    width: 101px;
    height: 176px;

    .score{
        position: absolute;
        left: 50%;
        bottom: 25px;
        transform: translateX(-50%);
        font-size: 18px;
        color: #ffffc1;
    }
}

@for $i from 1 through 8 {

    @for $k from 1 through 5 {
        .player-item.t-#{$i}.p-#{$k} {
            background-image: url(~@/assets/images/modal/#{$i}/#{$k}.png);
        }
    }
}
}

@include responseTo("phone"){

.u-btn.close{
    top: 105%;
    left: 50%;
    transform: translateX(-50%);
}

.team-dialog{
    width: 734px;
    height: 1005px;
    background-image: url(~@/assets/images/modal/bg-modal-m.png);  
}

.name-label{
    position: absolute;
    right: 0px;
    top: 14px;
    width: 32px;
    height: 93px;  
    background-repeat : no-repeat;
}

@for $i from 1 through 8 {

    @for $k from 1 through 5 {
        .name-label.t-#{$i}.p-#{$k} {
            background-image: url(~@/assets/images/modal/name/#{$i}-#{$k}.png);
        }
    }
}

.title{
    width: 100%;
    height: 63px;
    margin: 0 auto 20px;
    background-repeat : no-repeat;
    background-position : center;
    
    background-image: url(~@/assets/images/modal/title-team_m.png);  
}

.team-view{
    margin : 0 20px;
}

.scroll-area{
    height: 850px;
    margin: 0 auto;
}

.team-pannel{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-left: 20px;
}

.player-item{
    position: relative;
    width: 130px;
    height: 228px;

    .score{
        position: absolute;
        left: 50%;
        bottom: 35px;
        transform: translateX(-50%);
        font-size: 18px;
        color: #ffffc1;
    }
}

@for $i from 1 through 8 {

    @for $k from 1 through 5 {
        .player-item.t-#{$i}.p-#{$k} {
            background-image: url(~@/assets/images/modal/#{$i}m/#{$k}.png);
        }
    }
}
}
</style>